import { render, staticRenderFns } from "./SearchPageView.vue?vue&type=template&id=50729adc&scoped=true"
import script from "./SearchPageView.vue?vue&type=script&lang=js"
export * from "./SearchPageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50729adc",
  null
  
)

export default component.exports